// expects a date string in ISO format and returns a date object created from
// it
export function normalizeDate(dateString: string) {
  const ms: number = Date.parse(dateString);
  if (Number.isNaN(ms)) {
    // special handling?
  }
  return new Date(ms);
}

// expects a date in ISO format and returns a formatted string
export function normalizeDateString(dateString: string) {
  const date: Date = normalizeDate(dateString);
  // format the individual components of the date like: February 28, 2022
  // the format as a whole is locale dependent; we just specify how each
  // piece should be (e.g. February instead of Feb)
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

// expects a date in ISO format and returns a formatted string
export function normalizeDateWithDay(dateString: string) {
  const date: Date = normalizeDate(dateString);

  // format the individual components of the date like: Monday, February 28, 2022
  return date.toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
